import { useParams } from 'react-router-dom';

export function useLocalizedPath() {
  const { lang } = useParams<{ lang?: string }>();
  return (path: string) => (lang && lang !== 'en' ? `/${lang}${path}` : path);
}
